import {  IServerSideGetRowsRequest } from '@ag-grid-community/core';
import { Action } from '@ngrx/store';
import { IFilterProfile } from 'src/app/interfaces/tankProfile';
import { IUsageDTO } from '../../utilities/iUsageDTO';

export const CHANGE_FILTER_PROFILE = '[FILTER] Filter Profile Changed';
export const CHANGE_TANK_GRID_REQUEST = '[FILTER] Change Tank Grid Filter';
export const CHANGE_TANK_FILTER = '[FILTER] Change Tank Filter';
export const SPARKLINE_USAGE = '[USAGE] Sparkline';
export const TANK_GRID_FILTER_UPDATED = '[FILTER] Tank Grid Filter Changed';
export const LOAD_PREVIOUSLY_SELECTED_TANKS =
  '[FILTER] LoadPreviouslySelectedTanks';
export const UPDATE_SELECTED_TANKS = '[FILTER] UpdateSelectedTanks';
export const SET_FILTER_PROFILES = '[FILTER] Set Filter Profiles';
export const SHOW_ALL_GATEWAYS = '[FILTER] Show All Gateways'

export class ChangeFilterProfile implements Action {
  readonly type = CHANGE_FILTER_PROFILE;

  constructor(public payload: IFilterProfile) {}
}

export class SetFilterProfiles implements Action {
  readonly type = SET_FILTER_PROFILES;

  constructor(public payload: IFilterProfile[]) {}
}

export class ChangeTankGridFilter implements Action {
  readonly type = CHANGE_TANK_GRID_REQUEST;

  constructor(
    public payload: IServerSideGetRowsRequest,
    public source: string,
  ) {  }
}

export class SparklineUsage implements Action {
  readonly type = SPARKLINE_USAGE;

  constructor(public payload: IUsageDTO) {}
}


export class LoadPreviouslySelectedTanks implements Action {
  readonly type = LOAD_PREVIOUSLY_SELECTED_TANKS;

  constructor(public payload: any[]) {}
}

export class UpdateSelectedTanks implements Action {
  readonly type = UPDATE_SELECTED_TANKS;

  constructor(public payload: any[]) {}
}

export class ChangeTankFilter implements Action {
  readonly type = CHANGE_TANK_FILTER;

  constructor(public payload: {
    [colId: string]: any;
  } | null, public source: string) {}
}

export class ShowAllGateways implements Action {
  readonly type = SHOW_ALL_GATEWAYS;

  constructor(public payload: boolean){}
}

export type Actions =
  | ChangeFilterProfile
  | SetFilterProfiles
  | ChangeTankGridFilter
  | SparklineUsage
  | LoadPreviouslySelectedTanks
  | UpdateSelectedTanks
  | ShowAllGateways
  | ChangeTankFilter;

